export const SENSITIVE_FIELDS = [
  'email',
  'phone',
  'image',
  'profileImage',
  'password',
  'address',
];

export const isSensitiveField = (fieldName: string): boolean => {
  return SENSITIVE_FIELDS.includes(fieldName);
};

export const AUDIT_LOG_API_BASE = '/auditlog';
export const AUDIT_LOG_LIST_ENDPOINT = `${AUDIT_LOG_API_BASE}/list`;
export const AUDIT_LOG_LOG_AUDIT_ENDPOINT = `${AUDIT_LOG_API_BASE}/log-audit`;
export const getAuditLogByIdEndpoint = (id: number | string): string => {
  return `${AUDIT_LOG_API_BASE}/${id}`;
};

export const DEFAULT_SORT_FIELD = 'timestamp';
export const DEFAULT_SORT_DIRECTION = 'desc' as const;

export enum AuditModule {
  Student = 155,
  Case = 156,
  CaseBehaviour = 157,
  CaseStrategy = 158,
  CaseAssessment = 159,
  DataCollection = 160,
  BipTemplate = 161,
  Incident = 162,
  UserManagement = 163,
  OrganizationSettings = 164,
  Authentication = 165,
  ProgressReport = 166,
  CaseMember = 167,
  CaseAttachment = 168,
  FidelityCheck = 169,
  CaseFeedback = 170,
  InsightAdmin = 186,
  Reports = 190,
  Dashboard = 193,
}

export enum AuditOperationType {
  Created = 171,
  Updated = 172,
  Deleted = 173,
  Viewed = 174,
  Exported = 175,
  Login = 176,
  Logout = 177,
  Approved = 178,
  Rejected = 179,
  StatusChanged = 180,
  Imported = 181,
  Uploaded = 182,
  Downloaded = 183,
  Moved = 184,
  Printed = 185,
}
